import { render, staticRenderFns } from "./Formpage.vue?vue&type=template&id=4283ab07&scoped=true&"
import script from "./Formpage.vue?vue&type=script&lang=js&"
export * from "./Formpage.vue?vue&type=script&lang=js&"
import style0 from "./Formpage.vue?vue&type=style&index=0&id=4283ab07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4283ab07",
  null
  
)

export default component.exports